import { useEffect, useRef } from "react";

interface LoaderProps {
  isLoading?: boolean;
  onLoad?: () => void;
}

export function Loader({ isLoading, onLoad }: LoaderProps) {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (!isLoading && entries[0].isIntersecting) {
          onLoad?.();
        }
      },
      { threshold: 0 }
    );

    if (container.current) {
      observer.observe(container.current);
    }

    return () => observer.disconnect();
  }, [isLoading, onLoad]);

  // adding 1px height to make the intersection observer work
  return <div style={{ height: 1 }} ref={container} />;
}
